import { Page, PageFEDSA } from 'components/layout';
import Tabs, { Tab, TabPanel } from '@ingka/tabs';
import React, { useState, useEffect, useRef } from 'react';
import Search from '@ingka/search';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'Store/store';
import EuSubmitRegistery from 'pages/EuSubmitRegistery/euSubmitRegistery';
import { useNavigate } from 'react-router-dom';
import GlobalSearch from 'components/GlobalSearch/globalSearch';
import { getEuStatusList } from 'Action/euPendingApprovalAction';
import Button from '@ingka/button';
import EuArchived from 'pages/EuArchived/euArchived';

const FileUpload = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10%;
`;

export const EuSupplier = (props: any) => {
  const { tabChange, items, setQuery, setShowDetailsData } = props;
  const [archivedQuery, setArchivedQuery] = useState('');
  const [submitRegistryQuery, setSubmitRegistryQuery] = useState('');
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState('Supplier');
  const [tabChanged, setTabChanged] = useState(false);
  const submittedToEUTabRef = useRef<HTMLButtonElement>(null);
  const [activeTab, setActiveTab] = useState('tab_10');
  const [supplierDDSRefNum, setSupplierDDSRefNum] = useState<string | null>(null);
  const [fedsa_RefNum, setFedsa_RefNum] = useState<string | null>(null);

  useEffect(() => {
    dispatch(getEuStatusList('Supplier'));
    dispatch(getEuStatusList('IKEA'));
  }, []);

  const handleTabChange = (tabChange) => {
    setSelectedStatus(tabChange);

    if (tabChange === 'Supplier') {
      setTabChanged(true);
      setArchivedQuery('');
      setActiveTab('tab_10');
      handleArchivedSearch('');
    } else if (tabChange === 'IKEA') {
      setSubmitRegistryQuery('');
      handleSubmitRegistrySearch('');
      setTabChanged(true);
      setActiveTab('tab_9');
    }
  };
  const handleArchivedSearch = (query) => {
    setArchivedQuery(query);
  };
  const handleSubmitRegistrySearch = (queries) => {
    setSubmitRegistryQuery(queries);
  };
  useEffect(() => {
    if (selectedStatus === 'Supplier') {
      dispatch(getEuStatusList(selectedStatus));
    } else if (selectedStatus === 'IKEA') {
      dispatch(getEuStatusList(selectedStatus));
    }
  }, [selectedStatus]);

  useSelector((state: RootState) => state.euFileUploadDetails);
  useSelector((state: RootState) => state.error);
  const navigate = useNavigate();
  const onClick = () => {
    navigate('/eusuppliers/fileupload');
  };
  const tabContainerStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
  };

  const tabs = [
    <div key="EuSupplierkey" style={tabContainerStyle}>
      <Tab
        key="tab-10"
        text={'Supplier data'}
        tabPanelId="tab_10"
        onClick={() => handleTabChange('Supplier')}
      />
      <Tab
        key="tab-9"
        text={'Submitted to EU registry'}
        tabPanelId="tab_9"
        onClick={() => handleTabChange('IKEA')}
        ref={submittedToEUTabRef}
      />
    </div>,
  ];

  const tabPanels = [
    <TabPanel key="archivedPanel" tabPanelId="tab_10" style={{ padding: 0 }}>
      <EuArchived
        queries={archivedQuery}
        setQuery={setArchivedQuery}
        tabChange={tabChange}
        items={items}
        handleTabChange={handleTabChange}
        supplierDDSRefNum={supplierDDSRefNum}
        setSupplierDDSRefNum={setSupplierDDSRefNum}
        setSelectedStatus={setSelectedStatus}
        setActiveTab={setActiveTab}
        setFedsa_RefNum={setFedsa_RefNum}
        fedsa_RefNum={fedsa_RefNum}
        selectedStatus={selectedStatus}
      />
    </TabPanel>,
    <TabPanel key="submitRegisteryPanel" tabPanelId="tab_9" style={{ padding: 0 }}>
      <EuSubmitRegistery
        queries={submitRegistryQuery}
        setQuery={setSubmitRegistryQuery}
        tabChange={tabChange}
        items={items}
        handleTabChange={handleTabChange}
        setActiveTab={setActiveTab}
        setSelectedStatus={setSelectedStatus}
        setSupplierDDSRefNum={setSupplierDDSRefNum}
        fedsa_RefNum={fedsa_RefNum}
        setFedsa_RefNum={setFedsa_RefNum}
        selectedStatus={selectedStatus}
      />
    </TabPanel>,
  ];
  const getSearchHandler = () => {
    switch (selectedStatus) {
      case 'Supplier':
        return handleArchivedSearch;
      case 'IKEA':
        return handleSubmitRegistrySearch;
      default:
        return () => {};
    }
  };
  return (
    <PageFEDSA>
      <div className="tab-header">
        <div className="pending-container">
          <FileUpload style={{ display: 'flex', justifyContent: 'space-between', padding: 16 }}>
            <GlobalSearch
              queries={selectedStatus === 'Supplier' ? archivedQuery : submitRegistryQuery}
              setQuery={selectedStatus === 'Supplier' ? setArchivedQuery : setSubmitRegistryQuery}
              onSearch={getSearchHandler()}
              tabChange={handleTabChange}
              tabChanged={tabChanged}
              setTabChanged={setTabChanged}
            />

            <Button
              className="UploadSubmission"
              text="Upload Submission"
              size="xsmall"
              onClick={onClick}
            />
          </FileUpload>

          <Tabs
            tabs={tabs}
            tabPanels={tabPanels}
            defaultActiveTab="tab_10"
            activeTab={activeTab}
            ariaLabel="Example Tabs Label"
            className="parent-tab"
          />
        </div>
      </div>
    </PageFEDSA>
  );
};
